import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {NgxSmartModalService} from 'ngx-smart-modal';
import {PageContentFunction} from '@app/models/help/pagecontentfunction.model';
import {DataType} from "@app/models/shared/datatype.enum";

@Component({
  selector: 'app-functions',
  templateUrl: './functions.component.html',
  styleUrls: ['./functions.component.scss']
})
export class FunctionsComponent implements OnInit {

  @ViewChild('functionSelectComponent', { static: true }) protected functionSelectComponent;

  @Output() functionsChanged = new EventEmitter<PageContentFunction[]>();

  public pageContentFunctions: PageContentFunction[];
  public allPageContentFunctions: PageContentFunction[];

  public filterColumnText: string;
  public page = 1;
  public itemsPerPage = 6;
  public maxSize = 10;
  public numPages = 1;
  public length = 0;
  public paginationEnabled = false;

  public rows: Array<any> = [];

  public isCheckAll: boolean = false;

  constructor(public ngxSmartModalService: NgxSmartModalService) {
  }

  ngOnInit() {
  }

  private dataSourceChanged() {
    this.length = this.pageContentFunctions.length;
    this.onChangeTable();
    this.paginationEnabled = this.pageContentFunctions && this.pageContentFunctions.length > 0;
  }

  public changePage(page: any, data: Array<any> = this.pageContentFunctions): Array<any> {
    const start = (page.page - 1) * page.itemsPerPage;
    const end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  public onChangeTable(page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
    this.rows = page ? this.changePage(page, this.pageContentFunctions) : this.pageContentFunctions;
    this.length = this.pageContentFunctions.length;
  }

  public setComponentData(pageContentFunctions: PageContentFunction[]) {
    this.clearState();
    this.allPageContentFunctions = pageContentFunctions;
    this.pageContentFunctions = [...this.allPageContentFunctions];
    this.filterDeletedItems();
    this.dataSourceChanged();
  }

  public clearState() {
    this.isCheckAll = false;
    this.paginationEnabled = false;
    this.filterColumnText = null;
    this.functionSelectComponent.clearState();
  }

  public updateFilter(event) {
    this.filterDeletedItems();
    if (this.filterColumnText) {
      this.pageContentFunctions = [...this.pageContentFunctions.filter(p => p.categoryName.toLowerCase().indexOf(this.filterColumnText.toLowerCase()) >= 0 || p.functionName.toLowerCase().indexOf(this.filterColumnText.toLowerCase()) >= 0)];
    }
    this.dataSourceChanged();
  }

  public removeFunction(pageContentFunction: PageContentFunction) {
    if (pageContentFunction.dataType == DataType.New) {
      let index = this.allPageContentFunctions.indexOf(pageContentFunction);
      this.allPageContentFunctions.splice(index, 1);
    } else {
      pageContentFunction.dataType = DataType.Deleted;
    }
    this.filterDeletedItems();
    this.dataSourceChanged();
  }

  private filterDeletedItems() {
    this.pageContentFunctions = [...this.allPageContentFunctions ? this.allPageContentFunctions.filter(p => p.dataType != DataType.Deleted) : []];
  }

  public removeSelectedFunctions() {
    let selectedFunctions = this.allPageContentFunctions.filter(x => x.isChecked);
    let removedItems = [];
    selectedFunctions.forEach(removable => {
      let itemToRemove = this.allPageContentFunctions.find(x => x.functionId === removable.functionId);
      if (itemToRemove.dataType == DataType.NoChange) {
        itemToRemove.dataType = DataType.Deleted;
      } else if (itemToRemove.dataType == DataType.New) {
        let index = this.allPageContentFunctions.indexOf(itemToRemove);
        let removedItem = this.allPageContentFunctions.splice(index, 1)[0];
        removedItems.push(removedItem);
      }
    });
    removedItems.forEach(item => {
      let index = this.pageContentFunctions.indexOf(item);
      this.pageContentFunctions.splice(index, 1);
    });
    this.filterDeletedItems();
    this.dataSourceChanged();
    this.isCheckAll = false;
    this.functionsChanged.emit(this.allPageContentFunctions);
  }

  public showRemoveSelectedButton() {
    if (!this.allPageContentFunctions)
      return false;
    const selectedPageContentFunctions = this.allPageContentFunctions.filter(x => x.isChecked);
    return (selectedPageContentFunctions && selectedPageContentFunctions.length > 0);
  }

  public onFunctionsAdded(pageContentFunctions: PageContentFunction[]) {
    if (!this.pageContentFunctions) {
      this.pageContentFunctions = [];
    }
    pageContentFunctions.forEach(pageContentFunction => {
      if (!this.allPageContentFunctions){
        this.allPageContentFunctions = [];
      }
      let existingPageContentFunction = this.allPageContentFunctions.find(p => p.functionId == pageContentFunction.functionId);
      if (existingPageContentFunction) {
        if (existingPageContentFunction.dataType == DataType.Deleted) {
          existingPageContentFunction.dataType = DataType.NoChange;
        }
      } else {
        this.allPageContentFunctions.push(pageContentFunction);
      }
    });
    this.filterDeletedItems();
    this.dataSourceChanged();
    this.functionsChanged.emit(this.allPageContentFunctions);
    this.ngxSmartModalService.getModal("selectFunction").close();
  }

  public addFunction() {
    this.functionSelectComponent.setComponentData(this.pageContentFunctions ? this.pageContentFunctions.filter(p => p.dataType != DataType.Deleted) : []);
    this.ngxSmartModalService.getModal("selectFunction").open();
  }

  public showTable() {
    return this.allPageContentFunctions && this.allPageContentFunctions.length > 0;
  }

  public selectAll() {
    this.rows.forEach(x => {
      x.isChecked = this.isCheckAll;
    });
  }

  public getSelectedCountText() {
    if (!this.allPageContentFunctions || this.allPageContentFunctions.length <= 0) {
      return null;
    }
    let selectedItems = this.allPageContentFunctions.filter(p => p.isChecked);
    if (!selectedItems || selectedItems.length <= 0) {
      return null;
    }
    if (selectedItems.length == 1) {
      return '1 function selected';
    }
    return selectedItems.length + ' functions selected';
  }

  public unSelectAll($event) {
    $event.preventDefault();
    this.allPageContentFunctions.forEach(x => {
      x.isChecked = false;
    });
    this.isCheckAll = false;
  }
}
